module.exports = __webpack_public_path__ + "img/map.6d54374b.svg";